module.exports = __webpack_public_path__ + "static/media/build_black_24dp.37ae06b3.svg";